import Box from '@mui/material/Box';
import { AudiencesTable } from './sections/Audiences/AudiencesTable.tsx';
import { DeliveryByAdDurationTable } from './sections/DeliveryByAdDurationTable/DeliveryByAdDurationTable.tsx';
import { DeliveryByAdSizeTable } from './sections/DeliveryByAdSizeTable/DeliveryByAdSizeTable.tsx';
import { DeliveryByDomainBundleTable } from './sections/DeliveryByDomainBundleTable/DeliveryByDomainBundleTable.tsx';

export const DealInsightsDelivery = () => {
  return (
    <Box component="section" data-test="deal-insights-delivery">
      <DeliveryByDomainBundleTable />
      <DeliveryByAdSizeTable />
      <DeliveryByAdDurationTable />
      <AudiencesTable />
    </Box>
  );
};
